"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSpecialFunctionCheck = void 0;
function isSpecialFunctionCheck(attr) {
    if (!attr)
        return false;
    return !!attr.special_fn_type;
}
exports.isSpecialFunctionCheck = isSpecialFunctionCheck;
